import styles from "./Profile.module.css";

const ProfileBanner = ({ profile_image, banner }) => {
  return (
    <div className="banner-upload-container" style={{ position: "relative" }}>
      <div className="banner-frame">
        {banner ? (
          <img src={banner} alt="Banner" className="banner-image" />
        ) : (
          <div className="placeholder"></div>
        )}
      </div>
      <img src={profile_image} alt="" className={styles.banner_profile} />
    </div>
  );
};

export default ProfileBanner;
